import { IFormatObjectEditable } from "..";
import { IFormatAlert } from "../IFormatAlert";
import { IObjectValidator } from "../IObjectValidator";
import { CircleSelectObjectEditor } from "../objectEditors";
import { AbstractFormatObjectAlert, RegisterableAlert } from "../alerts";

export class CircleSelectObjectValidator implements IObjectValidator {
  public validate(object: IFormatObjectEditable): IFormatAlert[] {
    const alerts: AbstractFormatObjectAlert[] = [];
    if (object instanceof CircleSelectObjectEditor) {
      if (!object.categoryName().getValue()) {
        alerts.push(new RegisterableAlert(object, "分類名が未設定です。"));
      }
    }
    return alerts;
  }
}
